let activeQuickview = null;
let activeTrigger = null;

function triggersFor(quickview) {
  return Array.from(document.querySelectorAll('[data-show="quickview"]')).filter(
    (trigger) => trigger.dataset.target === quickview.id
  );
}

function backdrop() {
  let element = document.querySelector("[data-quickview-backdrop]");

  if (!element) {
    element = document.createElement("div");
    element.className = "quickview-backdrop";
    element.dataset.quickviewBackdrop = "true";
    element.setAttribute("aria-hidden", "true");
    document.body.appendChild(element);
  }

  return element;
}

function closeQuickview({ restoreFocus = true } = {}) {
  if (!activeQuickview) return;

  const quickview = activeQuickview;
  const trigger = activeTrigger;

  quickview.classList.remove("is-active");
  quickview.setAttribute("aria-hidden", "true");
  triggersFor(quickview).forEach((item) => item.setAttribute("aria-expanded", "false"));
  backdrop().classList.remove("is-active");
  document.body.classList.remove("has-quickview-open");

  activeQuickview = null;
  activeTrigger = null;

  if (restoreFocus && trigger?.isConnected) trigger.focus();
}

function openQuickview(trigger, quickview) {
  if (activeQuickview === quickview) {
    closeQuickview();
    return;
  }

  closeQuickview({ restoreFocus: false });

  activeQuickview = quickview;
  activeTrigger = trigger;
  quickview.classList.add("is-active");
  quickview.setAttribute("aria-hidden", "false");
  triggersFor(quickview).forEach((item) => item.setAttribute("aria-expanded", "true"));
  backdrop().classList.add("is-active");
  document.body.classList.add("has-quickview-open");

  window.requestAnimationFrame(() => {
    quickview.querySelector("[data-quickview-close]")?.focus();
  });
}

document.addEventListener("click", (event) => {
  const trigger = event.target.closest('[data-show="quickview"]');

  if (trigger) {
    const quickview = document.getElementById(trigger.dataset.target);
    if (!quickview) return;

    event.preventDefault();
    openQuickview(trigger, quickview);
    return;
  }

  if (event.target.closest('[data-dismiss="quickview"]')) {
    event.preventDefault();
    closeQuickview();
    return;
  }

  if (event.target.closest("[data-quickview-backdrop]")) closeQuickview();
});

document.addEventListener("keydown", (event) => {
  if (event.key === "Escape" && activeQuickview) closeQuickview();
});

document.addEventListener("turbo:before-cache", () => closeQuickview({ restoreFocus: false }));
